import clsx from 'clsx';
import Avatar from '../../Avatar';
import styles from './MembersDialog.module.css';
import { Avatar as AvatarT } from './index';
import getMemberDisplayName from 'src/utils/getMemberDisplayName';

const MembersDialog = ({ member, disabled = false }: { member: AvatarT; disabled?: boolean }) => {
  const nameToShow = getMemberDisplayName(member);
  return (
    <div className={clsx(styles.item, disabled && styles.disabledItem)}>
      <div className={styles.avatar}>
        <Avatar size={24} thumbnail={member.thumbnail} name={nameToShow} />
      </div>
      <span className={styles.name}>{nameToShow}</span>
    </div>
  );
};
export default MembersDialog;
